<template lang="pug">
  section.icon-columns__container
    .container.icon-columns
      h2.icon-columns__title {{ title }}
      p.icon-columns__subheading(v-if="subheading") {{ subheading }}
      .icon-columns__link
        a.u-link(v-if="topLinkText", :href="topLinkUrl") {{ topLinkText }}
      .icon-columns__blocks
        slot
      LinkButton.icon-columns__button(v-if="bottomButtonText", :label="bottomButtonText", :href="bottomButtonUrl")
</template>

<script>
import LinkButton from 'scripts/components/buttons/LinkButton.vue'

export default {
  name: 'IconColumns',
  components: {
    LinkButton
  },
  props: {
    title: String,
    subheading: {
      type: String,
      default: null
    },
    topLinkText: String,
    topLinkUrl: String,
    bottomButtonText: String,
    bottomButtonUrl: String,
    icons: Array
  }
}
</script>

<style lang="scss" scoped>
.icon-columns {
  text-align: center;

  &.container {
    max-width: 900px;
  }

  &__container {
    margin-top: 54px;
    margin-bottom: 54px;
    width: 100%;
  }

  &__title {
    text-transform: uppercase;
    font-size: rem(18);
    line-height: rem(23);
    font-weight: 900;
    letter-spacing: 3px;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  &__subheading {
    margin-bottom: 36px;
    line-height: rem(28);
  }

  &__link {
    margin-top: 9px;
    margin-bottom: 18px;

    @include desktop-up {
      margin-bottom: 36px;
    }

    a::after {
      // thin underline for this particular link
      bottom: 2px;
      height: 1px;
    }
  }

  &__button {
    margin-top: $content-gutter * 2;

    @include tablet-up {
      margin-top: $content-gutter * 3;
    }
  }

  &__blocks {
    display: flex;
    flex-direction: column;
    align-items: center;

    @include tablet-up {
      flex-direction: row;
      align-items: flex-start;
    }
  }
}
</style>